export class KeyPair {
  Id: number;
  Value: string;

  constructor(id: number, value: string) {
    this.Id = id;
    this.Value = value;
  }
}

export class KeyTriple extends KeyPair {
  DisplayId: number;
}

export class KeyPairWithDefault extends KeyPair {
  IsDefault: boolean;
}

export class KeyValuePair {
  Key: string;
  Value: string;

  constructor(key: string, value: string) {
    this.Key = key;
    this.Value = value;
  }
}

export class KeyBooleanPair {
  Key: string;
  Value: boolean;

  constructor(key: string, value: boolean) {
    this.Key = key;
    this.Value = value;
  }
}

export class Enum {
  Id: string;
  Value: string;

  constructor(id: string, value: string) {
    this.Id = id;
    this.Value = value;
  }
}

export class EnumWithDefault {
  Id: string;
  Value: string;
  IsDefault: boolean;
}
